import script from "./UserIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./UserIndex.vue?vue&type=script&setup=true&lang=js"

import "./UserIndex.vue?vue&type=style&index=0&id=3acad419&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3acad419"]])

export default __exports__